<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <h2 class="mx-3" v-if="$vuetify.display.mdAndUp">Calendario</h2>
          <h3 class="mx-3" v-else>Calendario</h3>
        </div>
        <div class="d-flex align-center justify-end" >
        </div>
      </v-col>
      <v-col cols="12">
        <v-progress-linear color="primary" class="w-100" indeterminate v-if="loading" height="2"></v-progress-linear>
        <v-divider class="mb-3" v-else></v-divider>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <h4>Giorni di apertura della settimana</h4>
          </v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Lunedì" hide-details v-model="editingItem.open_days.lun" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Martedì" hide-details v-model="editingItem.open_days.mar" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Mercoledì" hide-details v-model="editingItem.open_days.mer" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Giovedì" hide-details v-model="editingItem.open_days.gio" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Venerdì" hide-details v-model="editingItem.open_days.ven" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Sabato" hide-details v-model="editingItem.open_days.sab" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Domenica" hide-details v-model="editingItem.open_days.dom" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-btn small color="primary" rounded @click="saveSettings()">Salva</v-btn></v-col>

          <v-col cols="12"><v-divider /></v-col>
          <v-col cols="12">
            <h4>Feste nazionali osservate dalla palestra (chiusura)</h4>
          </v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Natale" hide-details v-model="editingItem.holidays.natale" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Santo Stefano" hide-details v-model="editingItem.holidays.santo_stefano" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Capodanno" hide-details v-model="editingItem.holidays.capodanno" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Pasquetta" hide-details v-model="editingItem.holidays.pasquetta" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Festa della liberzione" hide-details v-model="editingItem.holidays.liberazione" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Festa del lavoro" hide-details v-model="editingItem.holidays.lavoro" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Festa della repubblica" hide-details v-model="editingItem.holidays.repubblica" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Ferragosto" hide-details v-model="editingItem.holidays.ferragosto" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Tutti i santi" hide-details v-model="editingItem.holidays.santi" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-checkbox label="Festa dell'Immacolata" hide-details v-model="editingItem.holidays.immacolata" /></v-col>
          <v-col cols="6" md="4" lg="3" xl="2" class="d-flex align-end"><v-btn small color="primary" rounded @click="saveSettings()">Salva</v-btn></v-col>
          <v-col cols="12"><v-divider /></v-col>
          <v-col cols="12">
            <h4>Periodi di ferie programmate</h4>
          </v-col>
          <v-col cols="12">
            <v-table density="compact" class="border rounded" striped="even">
              <thead>
              <tr>
                <th class="text-left">Dal</th>
                <th class="text-left">Al</th>
                <th class="text-left" style="width: 80px">Elimina</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in holidays" :key="item._id">
                <td>{{ formatDateTime(item.from) }}</td>
                <td>{{ formatDateTime(item.to) }}</td>
                <td><v-btn variant="text" color="error" @click="removeHoliday(item)" icon="mdi-close"></v-btn></td>
              </tr>
              </tbody>
            </v-table>
          </v-col>
          <v-col cols="12"><h4>Aggiungi periodo di ferie</h4></v-col>
          <v-col cols="12" lg="4">
            <v-text-field type="date" label="Dal" v-model="newHoliday.from" />
          </v-col>
          <v-col cols="12" lg="4">
            <v-text-field type="date" label="Al" v-model="newHoliday.to" />
          </v-col>
          <v-col cols="12" lg="4">
            <v-btn color="primary" @click="addHoliday()">Inserisci</v-btn>
          </v-col>

          <v-col cols="12"><h4>Aggiungi giorno/ora di ferie</h4></v-col>
          <v-col cols="12" sm="6" md="4" xl="3">
            <v-date-picker v-model="newHolidayDate" class="elevation-1" color="primary"></v-date-picker>
          </v-col>
          <v-col cols="12" sm="6" md="4" xl="3">
            <v-time-picker format="24hr" v-model="newHolidayTime" class="elevation-1" color="primary" :allowed-minutes="allowedMinutes" ></v-time-picker>
          </v-col>
          <v-col cols="12" sm="6" md="4" xl="3">
            <v-btn color="primary" @click="addHolidayDay()" class="ma-3">Inserisci giorno</v-btn>
            <v-btn color="primary" @click="addHolidayHour()" class="ma-3">Inserisci ora</v-btn>
          </v-col>

        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<script lang="ts">
import utils from '../utils';
import {DateTime} from "luxon";
import {computed, inject, onMounted, ref} from "vue";
import {type CalendarHour, type Holiday, SeatsType, type Settings} from "@/models.ts";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRouter} from "vue-router";
import api from "@/api";

export default {
  name: "Calendar",
  setup (props, ctx) {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const router = useRouter()

    const loading = ref(false)
    const editingItem = ref<Settings>({
      banner_duration: 0,
      booking_within_minutes_corsi: 0,
      booking_within_minutes_exp: 0,
      booking_within_minutes_gym: 0,
      booking_within_minutes_macchine: 0,
      booking_within_minutes_vacu: 0,
      bookings_per_hour_corsi: 0,
      bookings_per_hour_exp: 0,
      bookings_per_hour_gym: 0,
      bookings_per_hour_macchine: 0,
      bookings_per_hour_vacu: 0,
      coni_card_price: 0,
      day_of_sport_year_start: 0,
      extra_day_of_sub_pause_price: 0,
      max_days_of_subscription_pause: 0,
      month_of_sport_year_start: 0,
      home_kit_price : 0,
      home_kit_expedition_price : 0,
      home_kit_expedition_days : 0,
      purchase_expiration_days_after_first_use : 60,
      open_days : {
        lun: true,
        mar: true,
        mer: true,
        gio: true,
        ven: true,
        sab: true,
        dom: false,
      },
      user_bookings_per_week : 2,
      user_bookings_per_day : 1,
      cancel_within_minutes : 1,
      booking_within_minutes : 10,
      holidays : {
        natale : true,
        santo_stefano : true,
        capodanno : true,
        epifania : true,
        pasquetta : true,
        liberazione : true,
        lavoro : true,
        repubblica : true,
        ferragosto : true,
        santi : true,
        immacolata : true,
      }
    })

    const newHoliday = ref<Holiday>({
      from : '',
      to : ''
    })
    const newHolidayDate = ref<Date>(new Date())
    const newHolidayTime = ref<string>(DateTime.now().toFormat('HH') + ":00")
    const hours = ref<CalendarHour[]>([])
    const newHour = ref<CalendarHour>({
      name: '',
      type : SeatsType.exp,
      day : 1,
      time: "09:00",
      duration : 0,
      max_seats : 0,
      restricted : false,
      exclude_users : []
    })

    const refreshHours = async () => {
      loading.value = true;
      const res = await api.list<CalendarHour>('hours', {}, 0, 0, '+time')
          loading.value = false;
      if(!res.success) {
        messages.error(res.message ?? Msg.serverError)
        return
      }

      hours.value = res.data ?? []
    }

    onMounted(async ()=>{
      await auth.waitForLogin
      await globals.waitForInit

      await Promise.all([
        globals.refresh('holidays'),
        globals.loadSettings(),
        refreshHours()
      ])

      editingItem.value = {...globals.settings.value}
    })

    return {
      loading,
      editingItem,
      holidays : globals.holidays,
      newHoliday,
      newHolidayDate,
      newHolidayTime,
      hours,
      newHour,
      days : [
        { title : 'Lunedì', value : 1},
        { title : 'Martedì', value : 2},
        { title : 'Mercoledì', value : 3},
        { title : 'Giovedì', value : 4},
        { title : 'Venerdì', value : 5},
        { title : 'Sabato', value : 6},
        { title : 'Domenica', value : 0},
      ],
      lunHours: computed(()=>hours.value.filter(i => i.day === 1)),
      marHours: computed(()=>hours.value.filter(i => i.day === 2)),
      merHours: computed(()=>hours.value.filter(i => i.day === 3)),
      gioHours: computed(()=>hours.value.filter(i => i.day === 4)),
      venHours: computed(()=>hours.value.filter(i => i.day === 5)),
      sabHours: computed(()=>hours.value.filter(i => i.day === 6)),
      domHours: computed(()=>hours.value.filter(i => i.day === 0)),
      allowedMinutes: (v:number) => v === 0,
      formatDate : utils.formatDate,
      formatDateTime : utils.formatDateTime,
      addHoliday() {
        if(!newHoliday.value.from || !newHoliday.value.from) {
          messages.error("Inserisci delle date valide");
          return;
        }
        let from = utils.toDateTime(newHoliday.value.from);
        let to = utils.toDateTime(newHoliday.value.to);

        if(!from.isValid || !to.isValid) {
          messages.error("Inserisci delle date valide");
          return;
        }
        to = to.endOf("day")
        messages.requestConfirm("Richiesta conferma", "Vuoi davvero inserire questo periodo di chiusura della palestra?", false, async (confirmed) => {
          if(confirmed) {
            loading.value = true;
            let data = { from : from.toISO()!, to : to.toISO()! }
            const res = await api.post<Holiday>('holidays', data)
            loading.value = false
            if(!res.success) {
              messages.error(res.message ?? Msg.serverError)
              return
            }
            await globals.refresh('holidays')

          }
        });
      },
      addHolidayDay() {
        if(!newHolidayDate.value){
          messages.error("Inserisci una data valida");
          return;
        }


        let from = DateTime.fromJSDate(newHolidayDate.value).startOf("day");
        let to = DateTime.fromJSDate(newHolidayDate.value).endOf("day");


        messages.requestConfirm( "Richiesta conferma",  `Vuoi davvero inserire questo giorno di chiusura della palestra: ${from.toFormat('dd/MM/yyyy')}?`, false, async (confirmed) => {
          if(confirmed) {
            loading.value = true;
            let data = { from : from.toISO()!, to : to.toISO()! }
            const res = await api.post<Holiday>('holidays', data)
            loading.value = false
            if(!res.success) {
              messages.error(res.message ?? Msg.serverError)
              return
            }
            await globals.refresh('holidays')
          }
        });
      },
      addHolidayHour() {
        //console.log(newHolidayDate.value, newHolidayTime.value)
        if(!newHolidayDate.value || !newHolidayTime.value){
          messages.error("Inserisci una data e un ora valida");
          return;
        }

        console.log(newHolidayDate.value, newHolidayTime.value)

        const dt = DateTime.fromJSDate(newHolidayDate.value)

        let from = DateTime.fromFormat(`${dt.toISODate()} ${newHolidayTime.value}`, 'yyyy-MM-dd HH:mm').startOf("hour");
        let to = DateTime.fromFormat(`${dt.toISODate()} ${newHolidayTime.value}`, 'yyyy-MM-dd HH:mm').endOf("hour");

        messages.requestConfirm("Richiesta conferma", `Vuoi davvero inserire questa ora di chiusura della palestra: ${from.toFormat('dd/MM/yyyy HH:mm')}?`, false, async(confirmed) => {
          if(confirmed) {
            loading.value = true;
            let data = { from : from.toISO()!, to : to.toISO()! }
            const res = await api.post<Holiday>('holidays', data)
            loading.value = false
            if(!res.success) {
              messages.error(res.message ?? Msg.serverError)
              return
            }
            await globals.refresh('holidays')
          }

        });
      },

      removeHoliday( item:Holiday ) {

        messages.requestConfirm( "Richiesta conferma",  "Vuoi davvero eliminare questo periodo di chiusura della palestra?", false, async (confirmed) => {
          if(confirmed) {
            loading.value = true;
            const res = await api.del<Holiday>('holidays', item._id!)
            loading.value = false
            if(!res.success) {
              messages.error(res.message ?? Msg.serverError)
              return
            }
            await globals.refresh('holidays')
          }

        });

      },
      async saveSettings() {
        loading.value = true;
        const res = await api.put<Settings>('settings', editingItem.value, undefined, true)
        loading.value = false
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          return
        }
        editingItem.value = res.data!;
        globals.settings.value = {...editingItem.value}
      }
    }

  }
}
</script>

<style scoped></style>
